import Vue from 'vue'
import Router from 'vue-router'

// GENERAL
import Home from '@/pages/home/Home'
import Photo from '@/pages/photo/Photo'
import Restaurant from '@/pages/restaurant/Restaurant'
import Pets from '@/pages/pets/Pets'
import Convenience from '@/pages/convenience/Convenience'
import Contact from '@/pages/contact/Contact'
import Evaluation from '@/pages/evaluation/Evaluation'

// BEACH
import CanoaQuebrada from '@/pages/canoa-quebrada/CanoaQuebrada'
import KiteSurf from '@/pages/kite-surf/KiteSurf'

// BEDROOMS
import Bedroom from '@/pages/bedroom/Bedroom'
import Chale from '@/pages/bedroom/chale/Chale'
import DuploSuperior from '@/pages/bedroom/duplo-superior/DuploSuperior'
import DuploTerreo from '@/pages/bedroom/duplo-terreo/DuploTerreo'
import Suite from '@/pages/bedroom/suite/Suite'
import SuiteDeluxe from '@/pages/bedroom/suite-deluxe/SuiteDeluxe'

// RESERVATION
import SelectDates from '@/pages/reservation/SelectDates'
import RequestReservation from '@/pages/reservation/RequestReservation'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', name: 'Home', component: Home },
    { path: '/photo', name: 'Photo', component: Photo },
    { path: '/convenience', name: 'Convenience', component: Convenience },
    { path: '/restaurant', name: 'Restaurant', component: Restaurant },
    { path: '/pets', name: 'Pets', component: Pets },
    { path: '/canoa-quebrada', name: 'CanoaQuebrada', component: CanoaQuebrada },
    { path: '/kite-surf', name: 'KiteSurf', component: KiteSurf },
    // { path: '/contact', name: 'Contact', component: Contact },
    { path: '/evaluation', name: 'Evaluation', component: Evaluation },

    { path: '/bedroom', name: 'Bedroom', component: Bedroom },
    // { path: '/bedroom/:id', name: 'BedroomGeneric', component: ShowBedroom },
    { path: '/bedroom/chale', name: 'Chale', component: Chale },
    { path: '/bedroom/suite', name: 'Suite', component: Suite },
    { path: '/bedroom/suite-deluxe', name: 'SuiteDeluxe', component: SuiteDeluxe },
    { path: '/bedroom/duplo-superior', name: 'DuploSuperior', component: DuploSuperior },
    { path: '/bedroom/duplo-terreo', name: 'DuploTerreo', component: DuploTerreo },

    { path: '/reservation/select-dates', name: 'SelectDatesReservation', component: SelectDates },
    { path: '/reservation/request-reservation', name: 'RequestReservation', component: RequestReservation },

    { path: '*', redirect: { name: 'Home' } }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js